export default __webpack_public_path__ + "static/media/scanning-overriding.54051af5.svg";